import { ExtractedContract } from "../../types/contract";

export const detailFields: (keyof ExtractedContract)[] = [
  // 入居者情報
  "contractor_name",
  "contractor_gender",
  "contractor_work_info",
  "co_occupant_info",
  "emergency_contact_info",
  // 契約情報
  "rent",
  "management_fee",
  "contract_start_date",
  "contract_end_date",
  "renewal_fee_basis",
  "renewal_fee_value",
  "renewal_fee_period",
  "renewal_admin_fee",
  "guarantee_company_name",
  "guarantee_number",
  "insurance_company_info",
  "joint_guarantor_info",
  // その他
  "pet_info",
  "vehicle_info",
  "key_info",
  // 建物情報
  "property_address",
  "property_address2",
  "property_postal_code",
  "building_code",
  "building_name_kana",
  // 家主情報
  "owner_name",
  "owner_name_kana",
  "owner_type",
  "owner_company_name",
  "owner_postal_code",
  "owner_address1",
  "owner_address2",
  "owner_home_phone",
  "owner_mobile_phone",
  "owner_bank_1_branch_code",
  "owner_bank_1_account_type",
  "owner_bank_1_account_number",
  "owner_bank_1_account_holder_name",
  "owner_bank_2_branch_code",
  "owner_bank_2_account_type",
  "owner_bank_2_account_number",
  "owner_bank_2_account_holder_name",
];

export const fieldLabels: Record<string, string> = {
  // 入居者情報
  contractor_name: "契約者名",
  contractor_gender: "契約者性別",
  contractor_work_info: "契約者勤務先",
  co_occupant_info: "同居者情報",
  emergency_contact_info: "緊急連絡先",
  // 契約情報
  rent: "賃料",
  management_fee: "管理費",
  contract_start_date: "契約開始日",
  contract_end_date: "契約終了日",
  renewal_fee_basis: "更新料(基準)",
  renewal_fee_value: "更新料(値)",
  renewal_fee_period: "更新料(期間)",
  renewal_admin_fee: "更新事務手数料",
  guarantee_company_name: "保証会社名",
  guarantee_number: "保証番号",
  insurance_company_info: "保険会社情報",
  joint_guarantor_info: "連帯保証人情報",
  // その他
  pet_info: "ペット情報",
  vehicle_info: "車両情報",
  key_info: "鍵情報",
  // 建物情報
  property_address: "物件住所1",
  property_address2: "物件住所2",
  property_postal_code: "物件郵便番号",
  building_code: "建物コード",
  building_name_kana: "建物名フリガナ",
  // 家主情報
  owner_name: "家主名",
  owner_name_kana: "家主名フリガナ",
  owner_type: "家主種別",
  owner_company_name: "家主会社名",
  owner_postal_code: "家主郵便番号",
  owner_address1: "家主住所1",
  owner_address2: "家主住所2",
  owner_home_phone: "家主自宅Tel",
  owner_mobile_phone: "家主携帯電話番号",
  owner_bank_1_branch_code: "銀行支店コード1",
  owner_bank_1_account_type: "銀行区分1",
  owner_bank_1_account_number: "銀行番号1",
  owner_bank_1_account_holder_name: "銀行名義1",
  owner_bank_2_branch_code: "銀行支店コード2",
  owner_bank_2_account_type: "銀行区分2",
  owner_bank_2_account_number: "銀行番号2",
  owner_bank_2_account_holder_name: "銀行名義2",
};